import { FC, memo } from 'react';
import { EventFlowBase } from './EventFlowBase';
import { GradientRadioGroup } from '../prize-pools/GradientRadioGroup';
import Typography from '@mui/material/Typography';
import { useCreateEventContext } from '../../../contexts/organizer/create-event/CreateEventContext';
import { CREATION_METHODS } from 'src/contexts/organizer/create-event/constants';

export const SelectCreationMethod: FC = memo(
  function SelectCreationMethodUnmemoized() {
    const { eventCreationSettings, dispatchEventCreationSettings } =
      useCreateEventContext();
    const { eventType, method } = eventCreationSettings;
    return (
      <EventFlowBase
        title={`New/Copy ${eventType}`}
        subtitle={`Create a new ${eventType.toLowerCase()} from a template, or copy details from a previous ${eventType.toLowerCase()}`}
        Content={
          <GradientRadioGroup
            onValueChange={(index) => {
              return dispatchEventCreationSettings({
                type: 'SET_METHOD',
                // eslint-disable-next-line security/detect-object-injection
                payload: CREATION_METHODS[index],
              });
            }}
            selectedIndex={CREATION_METHODS.indexOf(method)}
            items={CREATION_METHODS.map((type) => {
              return {
                key: type,
                label: (
                  <Typography variant="subtitle1" color={'text.primary'}>
                    {type}
                  </Typography>
                ),
              };
            })}
          />
        }
        nextPageKey={method === 'New' ? 'Create Event' : 'Copy Event'}
      />
    );
  },
);
